import type { Item, ArticleChartType } from '../../types';

export const isArticleChart = (item: Item): item is ArticleChartType => {
	return !!(item && item.__typename === 'Article_Chart');
};
